import { useEffect } from 'react';

// components - authenticated pages
import { AdminBody } from './';

// components - gateway pages
import { LoginBody, UnauthorizedBody, createHomeProp, setNavigation } from './';

// client-shared
import { storage } from '@goldblack/client-storage';
import { ContainerMain } from '@goldblack/client-comps';
import { Box } from '@mui/material';

// Authenticated routes (login required)
function AuthenticatedRoutes() {
    const { main } = storage.transience.getValue();

    useEffect(() => {
        setNavigation(createHomeProp());
    }, []);

    const lastIndex = Math.max(0, main.containers.length - 1);
    return (
        <>
            {main.containers.map((props, index) => {
                const hidden = index !== lastIndex;
                return props.path === 'home' ? (
                    <Box
                        key={index}
                        hidden={hidden}
                        sx={{
                            display: hidden ? 'none' : 'flex',
                            width: '100vw',
                            height: '100vh',
                            overflow: 'hidden',
                            bgcolor: 'background.default',
                        }}>
                        <AdminBody config={props.config} />
                    </Box>
                ) : (
                    <></>
                );
            })}
        </>
    );
}

function UnauthenticatedRoutes({ path }) {
    const config = storage.localStorage.getValue('config');

    return path === 'login' ? (
        <ContainerMain width='xs' config={config.data} bodyContent={<LoginBody />} />
    ) : path === 'unauthorized' ? (
        <ContainerMain width='xs' config={config.data} bodyContent={<UnauthorizedBody />} />
    ) : (
        <></>
    );
}

// Gateway - handles all routing (both authenticated and unauthenticated)
function Gateway() {
    const path = storage.transience.getValue('path.gateway');

    // Authenticated → stack-based routing
    if (path === 'main') {
        return <AuthenticatedRoutes />;
    }

    return <UnauthenticatedRoutes path={path} />;
}

export { Gateway };
